import {
    Swiper,
    Navigation,
    Autoplay
} from 'swiper/js/swiper.esm.js';
import 'swiper/swiper.scss';


Swiper.use([Navigation, Autoplay]);

const heroSlider = new Swiper('.autoplay-slider', {
    speed: 1200,
    spaceBetween: 0,
    slidesPerView: 1,
    loop: true,
    preloadImages: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

const suggestedSlider = new Swiper('.suggested-slider', {
    speed: 1200,
    slidesPerView: 1.05,
    spaceBetween: 20,
    slidesOffsetBefore: 15,
    slidesOffsetAfter: 15,
    loop: false,
    preloadImages: false,
    breakpoints: {
		768: {
            spaceBetween: 20,
            slidesPerView: 2,
		},
		1024: {
			spaceBetween: 30,
            slidesPerView: 2,
            slidesOffsetBefore: 74,
            slidesOffsetAfter: 74,
        },
        1200: {
            spaceBetween: 30,
			slidesPerView: 2.8,
			slidesOffsetBefore: 74,
            slidesOffsetAfter: 74,
        }
    }
});

const gallerySlider = new Swiper('.gallery-slider', {
    speed: 1200,
    slidesPerView: 'auto',
    spaceBetween: 10,
	preloadImages: true,
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
	},
	breakpoints: {
        1024: {
            spaceBetween: 20,
        }
    }
});

const instaSlider = new Swiper('.insta-slider', {
    speed: 1200,
    spaceBetween: 30,
    slidesPerView: 1,
    loop: true,
    preloadImages: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
	},
    breakpoints: {
        1024: {
            spaceBetween: 30,
            slidesPerView: 3,
        }
    }
});